<template>
  <div class="animated fadeIn report main-div">
    <vLoading v-if="vLoading" />
    <div class="pe-6 ps-6 py-10">
      <v-row dir="ltr" class="pb-2">
        <v-col class="text-sm-left text-center">
          <v-btn
            to="/admin/advancedReport"
            class="bc-primary text-white no-underline"
            elevation="0"
            width="230"
            ><span class="c-light">بازگشت به صفحه اصلی</span></v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center fs-xlarge c-dark pt-sm-0 pt-6"
          ><span>گزارش فرد</span></v-col
        >
      </v-row>
      <hr class="my-4" />
      <div class="d-lg-block d-none" style="padding: 0 100px">
        <v-stepper v-model="stepNumber" alt-labels>
          <v-stepper-header>
            <v-stepper-step
              :complete="stepNumber > 1"
              :active-icon="'mdi-pen'"
              step="1"
            >
              <div @click="stepNumber = 1" class="text-center pointer">
                <p class="fs-xsmall mb-3">گام اول</p>
                <p class="mb-0">انتخاب فرد</p>
                <p v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
                  (
                  {{
                    selectedResearcher.name
                      ? selectedResearcher.name
                      : selectedReviewer.name
                  }}
                  )
                </p>
              </div>
            </v-stepper-step>

            <v-divider :class="stepNumber > 1 ? 'completed' : ''"></v-divider>

            <v-stepper-step step="2">
              <div class="text-center">
                <p class="fs-xsmall mb-3">گام دوم</p>
                <p class="mb-0">مشاهده و خروجی</p>
              </div>
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </div>
      <div class="d-lg-none d-sm-block d-none pt-4">
        <div class="d-flex flex-row justify-content-center c-grey">
          <div class="text-center">
            <span
              @click="stepNumber = 1"
              :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
              class="pointer"
              >انتخاب فرد</span
            >
            <p v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              (
              {{
                selectedResearcher.name
                  ? selectedResearcher.name
                  : selectedReviewer.name
              }}
              )
            </p>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>
          <div>
            <span
              :class="
                stepNumber == 2 ? 'c-pink' : stepNumber > 2 ? 'c-primary' : ''
              "
              >مشاهده و خروجی</span
            >
          </div>
        </div>
      </div>
      <div class="d-block d-sm-none text-center py-4">
        <div class="d-flex flex-column justify-content-center c-grey">
          <div class="text-center">
            <span
              @click="stepNumber = 1"
              :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
              >انتخاب فرد</span
            >
            <p v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              (
              {{
                selectedResearcher.name
                  ? selectedResearcher.name
                  : selectedReviewer.name
              }}
              )
            </p>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>
          <div>
            <span
              :class="
                stepNumber == 2 ? 'c-pink' : stepNumber > 2 ? 'c-primary' : ''
              "
              >مشاهده و خروجی</span
            >
          </div>
        </div>
      </div>
      <hr />
      <!-- Step 1 -->
      <div v-if="stepNumber == 1">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>

        <div v-else>
          <v-tabs v-model="personTab">
            <v-tab class="c-primary">پژوهشگران</v-tab>
            <v-tab class="c-primary">داوران</v-tab>
          </v-tabs>
          <v-tabs-items v-model="personTab">
            <!-- پژوهشگران -->
            <v-tab-item>
              <v-container>
                <v-row>
                  <v-col class="pt-6 text-sm-right text-center">
                    <span class="c-dark fs-large"
                      >پژوهشگر مورد نظر خود را انتخاب کنید.</span
                    >
                  </v-col>
                  <v-col sm="4" cols="12">
                    <v-text-field
                      rounded
                      filled
                      append-icon="mdi-close"
                      @click:append="filter = ''"
                      class="search-box mt-2 mt-sm-0"
                      placeholder="نام فرد را جستجو کنید..."
                      v-model="filter"
                      @input="goFirst('researcher')"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon class="ps-3 pe-3">$searchIcon</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <div
                  v-if="!computedResearchers.length"
                  class="text-center c-grey"
                >
                  <hr />
                  موردی یافت نشد.
                  <hr />
                </div>
                <div class="researchers-page">
                  <v-row>
                    <v-col
                      lg="3"
                      md="4"
                      sm="6"
                      cols="12"
                      v-for="(item, index) in computedResearchers"
                      :key="index"
                    >
                      <div
                        class="item-box d-flex flex-column py-6"
                        @click="choosePerson(item, 'researcher')"
                        :class="
                          selectedResearcher == item ? 'selected-box' : ''
                        "
                      >
                        <p class="mb-5 fs-large">{{ item.name }}</p>
                        <p class="mb-2 fs-medium">{{ item.mobile }}</p>
                        <span class="fs-medium">{{ item.natCode }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <div class="my-6">
                  <v-pagination
                    v-model="personsCurrentPage"
                    :length="
                      Math.ceil(
                        researchers.filter((x) => x.name.includes(filter))
                          .length / personPerPage
                      )
                    "
                    :total-visible="5"
                    prev-icon="arrow_back"
                    next-icon="arrow_forward"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-container>
            </v-tab-item>
            <!-- داوران -->
            <v-tab-item>
              <v-container>
                <v-row>
                  <v-col class="pt-6 text-sm-right text-center">
                    <span class="c-dark fs-large"
                      >داور مورد نظر خود را انتخاب کنید.</span
                    >
                  </v-col>
                  <v-col sm="4" cols="12">
                    <v-text-field
                      rounded
                      filled
                      append-icon="mdi-close"
                      @click:append="filter2 = ''"
                      class="search-box mt-2 mt-sm-0"
                      placeholder="نام فرد را جستجو کنید..."
                      v-model="filter2"
                      @input="goFirst('reviewer')"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon class="ps-3">$searchIcon</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <div
                  v-if="!computedReviewers.length"
                  class="text-center c-grey"
                >
                  <hr />
                  موردی یافت نشد.
                  <hr />
                </div>
                <div class="researchers-page">
                  <v-row>
                    <v-col
                      lg="3"
                      md="4"
                      sm="6"
                      cols="12"
                      v-for="(item, index) in computedReviewers"
                      :key="index"
                    >
                      <div
                        class="item-box d-flex flex-column py-6"
                        @click="choosePerson(item, 'reviewer')"
                        :class="selectedReviewer == item ? 'selected-box' : ''"
                      >
                        <p class="mb-5 fs-large">{{ item.name }}</p>
                        <p class="mb-2 fs-medium">{{ item.mobile }}</p>
                        <span class="fs-medium">{{ item.natCode }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <div class="my-6">
                  <v-pagination
                    v-model="personsCurrentPage2"
                    :length="
                      Math.ceil(
                        reviewers.filter((x) => x.name.includes(filter2))
                          .length / personPerPage
                      )
                    "
                    :total-visible="5"
                    prev-icon="arrow_back"
                    next-icon="arrow_forward"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>

      <!-- Step 2 -->
      <div v-if="stepNumber == 2 && selectedResearcher.id">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row class="my-4">
            <v-col class="d-flex flex-row">
              <div class="profileImg-box">
                <img
                  :src="
                    selectedResearcher.avatar
                      ? selectedResearcher.avatar
                      : 'https://www.luminous-edu.com/wp-content/uploads/2020/06/blank-profile-picture-973460_640.png'
                  "
                  alt=""
                />
              </div>
              <div class="pa-6 fs-large c-dark">
                {{ selectedResearcher.name }}
                <p class="fs-small grey--text">پژوهشگر</p>
              </div>
            </v-col>
            <v-col class="text-sm-left text-center">
              <v-btn
                class="bc-primary text-white btn-radius"
                width="200"
                height="47"
                elevation="0"
                @click="saveDocx('doc')"
              >
                <span class="fs-small">
                  خروجی ورد

                  <v-icon>$Word</v-icon></span
                >
              </v-btn>
            </v-col>
          </v-row>
          <v-tabs v-model="tab">
            <v-tab class="tab-title">مشخصات فرد</v-tab>
            <v-tab class="tab-title" v-if="deviceType == 'desktop'"
              >نمودار‌ها</v-tab
            >
            <v-tab class="tab-title">جدول‌ها</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <!-- مشخصات فرد -->
            <v-tab-item>
              <div class="py-10">
                <div class="fs-xxlarge c-dark text-right">مشخصات فردی</div>
                <v-card flat class="info-card mt-10 pa-sm-8 pe-0">
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >نام</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.name
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >آخرین مدرک تحصیلی</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.lastEducationDegree
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >نام خانوادگی</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.lastName
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >دانشگاه محل تحصیل</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.university
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >کد ملی</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.nationalCode
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >دانشگاه محل اشتغال
                          </span>
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.universityJob
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >استان</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.state
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark">
                            شماره تماس</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.mobile
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-tab-item>
            <!-- نمودارها -->
            <v-tab-item v-if="deviceType == 'desktop'">
              <v-container class="pe-10 ps-10 pt-12">
                <div class="text-center" v-if="computedCharts">
                  <hr />
                  موردی برای نمایش وجود ندارد.
                  <hr />
                </div>
                <div v-if="allData.barChartHasData" id="capture1" class="pa-6">
                  <v-row>
                    <v-col md="4" sm="6" cols="12"
                      ><h5 class="fs-xlarge">نمودار فراوانی حمایت‌ها</h5></v-col
                    >
                    <v-spacer></v-spacer>
                    <v-col class="text-left" md="4" sm="6" cols="12">
                      <span v-show="false">{{ reactivity }}</span>
                      <v-btn
                        class="bc-primary text-white btn-radius"
                        width="200"
                        height="47"
                        elevation="0"
                        @click="
                          capture('capture1', 'نمودار-فراوانی-حمایت‌ها', 0)
                        "
                        :loading="gettingPic[0]"
                        data-html2canvas-ignore
                      >
                        <template v-slot:loader>
                          <span class="white--text fs-xsmall d-flex flex-row">
                            <span
                              ><v-icon class="white--text"
                                >mdi-timer-sand-empty</v-icon
                              >
                              چند لحظه صبر کنید...
                            </span>
                          </span>
                        </template>
                        <span class="fs-small">
                          خروجی عکس

                          <v-icon>$Camera</v-icon></span
                        >
                      </v-btn>
                      <a id="download"></a>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-if="barBusy" class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="#068D9D"
                        class="align-middle button-td"
                      ></v-progress-circular>
                    </v-col>
                    <v-col v-else>
                      <Chart
                        name="barChart"
                        :chartdata="dataBar"
                        :options="optionsBar1"
                        type="bar"
                        :height="deviceType != 'mobile' ? '200' : '400'"
                        v-if="barLoaded"
                      ></Chart>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="allData.pieChartHasData" class="mt-16">
                  <div id="capture2" class="pa-6">
                    <v-row>
                      <v-col md="4" sm="6" cols="12"
                        ><h5 class="fs-xlarge">
                          نمودار تقسیم بندی نسبی حمایت‌ها
                        </h5></v-col
                      >
                      <v-spacer></v-spacer>
                      <v-col class="text-left" md="4" sm="6" cols="12">
                        <v-btn
                          class="bc-primary text-white btn-radius"
                          width="200"
                          height="47"
                          elevation="0"
                          data-html2canvas-ignore
                          :loading="gettingPic[1]"
                          @click="
                            capture(
                              'capture2',
                              'نمودار-تقسیم‌بندی-نسبی-حمایت‌ها',
                              1
                            )
                          "
                        >
                          <template v-slot:loader>
                            <span class="white--text fs-xsmall d-flex flex-row">
                              <span
                                ><v-icon class="white--text"
                                  >mdi-timer-sand-empty</v-icon
                                >
                                چند لحظه صبر کنید...
                              </span>
                            </span>
                          </template>
                          <span class="fs-small">
                            خروجی عکس

                            <v-icon>$Camera</v-icon></span
                          >
                        </v-btn>
                        <a id="download"></a>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col v-if="doughnutBusy" class="text-center">
                        <v-progress-circular
                          indeterminate
                          color="#068D9D"
                          class="align-middle button-td"
                        ></v-progress-circular>
                      </v-col>
                      <v-col v-else>
                        <v-row>
                          <v-col lg="5" cols="12" class="ps-lg-0">
                            <Chart
                              name="pieChart"
                              :chartdata="dataPie"
                              :options="optionsBar2"
                              type="doughnut"
                              v-if="doughnutLoaded"
                            ></Chart>
                          </v-col>
                          <v-col>
                            <v-row class="mt-lg-12">
                              <v-col
                                md="6"
                                cols="12"
                                class="pe-9 ps-9"
                                v-for="(item, index) in dataPie.labels"
                                :key="index"
                              >
                                <v-row class="c-grey mb-lg-3">
                                  <v-col cols="2">
                                    <v-icon
                                      :color="
                                        dataPie.datasets[0].backgroundColor[
                                          index
                                        ]
                                      "
                                      large
                                      >mdi-circle</v-icon
                                    >
                                  </v-col>
                                  <v-col class="pt-5">
                                    {{ dataPie.labels[index] }}
                                  </v-col>
                                  <v-col class="pt-5" cols="2">
                                    {{ dataPie.datasets[0].data[index] + "%" }}
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-container>
            </v-tab-item>
            <!-- جدول ها -->
            <v-tab-item>
              <div class="main-table">
                <div v-if="deviceType == 'mobile'">
                  <h4 class="mt-6 text-sm-right text-center">
                    جدول فراوانی حمایت‌ها
                  </h4>
                  <div class="text-sm-left text-center">
                    <v-btn
                      class="bc-primary text-white btn-radius mt-5 mb-10"
                      width="200"
                      height="47"
                      elevation="0"
                      @click="$refs.table1.$el.click()"
                    >
                      <span class="fs-small">
                        خروجی اکسل

                        <v-icon>$Excel</v-icon></span
                      >
                    </v-btn>
                    <vue-excel-xlsx
                      v-show="false"
                      ref="table1"
                      :data="barTable"
                      :columns="excelBarFields"
                      :filename="'جدول-فراوانی-حمایت‌ها'"
                      :sheetname="currentDate"
                    >
                      دریافت اکسل
                    </vue-excel-xlsx>
                  </div>
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                    :items="barTable"
                    :fields="barFields"
                    :current-page="barCurrentPage"
                    :per-page="perPage"
                    :filter="filter"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(mahvars)="data">
                      <div style="vertical-align: middle; max-width: 350px">
                        <ul>
                          <li v-for="(item, index) in data.value" :key="index">
                            {{ item }}
                          </li>
                        </ul>
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + perPage * (barCurrentPage - 1) + 1 }}
                      </div>
                    </template>
                  </b-table>
                  <v-row v-if="barTotalRows">
                    <v-col>
                      <v-pagination
                        v-model="barCurrentPage"
                        :length="Math.ceil(barTotalRows / perPage)"
                        :total-visible="5"
                        prev-icon="arrow_back"
                        next-icon="arrow_forward"
                        class="float-left"
                      ></v-pagination>
                    </v-col>
                  </v-row>

                  <h4 class="mt-10 text-sm-right text-center">
                    جدول تقسیم بندی نسبی حمایت‌ها
                  </h4>
                  <div class="text-sm-left text-center">
                    <v-btn
                      class="bc-primary text-white btn-radius mt-5 mb-10"
                      width="200"
                      height="47"
                      elevation="0"
                      @click="$refs.table2.$el.click()"
                    >
                      <span class="fs-small">
                        خروجی اکسل

                        <v-icon>$Excel</v-icon></span
                      >
                    </v-btn>
                    <vue-excel-xlsx
                      v-show="false"
                      ref="table2"
                      :data="pieTable"
                      :columns="excelPieFields"
                      :filename="'جدول-تقسیم-بندی-نسبی-حمایت‌ها'"
                      :sheetname="currentDate"
                    >
                      دریافت اکسل
                    </vue-excel-xlsx>
                  </div>
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                    :items="pieTable"
                    :fields="pieFields"
                    :current-page="pieCurrentPage"
                    :per-page="perPage"
                    :filter="filter"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(mahvars)="data">
                      <div style="vertical-align: middle; max-width: 350px">
                        <ul>
                          <li v-for="(item, index) in data.value" :key="index">
                            {{ item }}
                          </li>
                        </ul>
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + perPage * (pieCurrentPage - 1) + 1 }}
                      </div>
                    </template>
                  </b-table>
                  <v-row v-if="pieTotalRows">
                    <v-col>
                      <v-pagination
                        v-model="pieCurrentPage"
                        :length="Math.ceil(pieTotalRows / perPage)"
                        :total-visible="5"
                        prev-icon="arrow_back"
                        next-icon="arrow_forward"
                        class="float-left"
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </div>
                <h4 class="mt-10 text-sm-right text-center">
                  جدول فراوانی سال‌ها
                </h4>
                <div class="text-sm-left text-center">
                  <v-btn
                    class="bc-primary text-white btn-radius mt-5 mb-10"
                    width="200"
                    height="47"
                    elevation="0"
                    @click="$refs.table3.$el.click()"
                  >
                    <span class="fs-small">
                      خروجی اکسل

                      <v-icon>$Excel</v-icon></span
                    >
                  </v-btn>
                  <vue-excel-xlsx
                    v-show="false"
                    ref="table3"
                    :data="items"
                    :columns="excelFields"
                    :filename="'جدول-فراوانی-سال‌ها'"
                    :sheetname="currentDate"
                  >
                    دریافت اکسل
                  </vue-excel-xlsx>
                </div>
                <b-table
                  responsive
                  small
                  show-empty
                  stacked="sm"
                  tbody-tr-class="trClass"
                  thead-class="thClass"
                  empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                  :items="items"
                  :fields="Fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + perPage * (currentPage - 1) + 1 }}
                    </div>
                  </template>
                </b-table>
                <v-row v-if="totalRows">
                  <v-col>
                    <v-pagination
                      v-model="currentPage"
                      :length="Math.ceil(totalRows / perPage)"
                      :total-visible="5"
                      prev-icon="arrow_back"
                      next-icon="arrow_forward"
                      class="float-left"
                    ></v-pagination>
                  </v-col>
                </v-row>
                <div class="mt-12">
                  <v-expansion-panels accordion>
                    <v-expansion-panel @change="projectCurrentPage = 1">
                      <v-expansion-panel-header
                        >طرح های پیشنهادی فناورانه حمایت
                        شده</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <div class="py-6">
                          <v-row>
                            <v-col>
                              <b-table
                                responsive
                                small
                                show-empty
                                stacked="sm"
                                tbody-tr-class="trClass"
                                thead-class="thClass"
                                empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                :items="projects.items1"
                                :fields="projectFields"
                                :current-page="projectCurrentPage"
                                :per-page="perPage"
                                :filter="filter"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(progress)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{
                                      data.value != "-"
                                        ? "%" + data.value
                                        : data.value
                                    }}
                                  </div>
                                </template>
                                <template v-slot:cell(mehvar)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{
                                      data.index +
                                      perPage * (projectCurrentPage - 1) +
                                      1
                                    }}
                                  </div>
                                </template>
                              </b-table>
                              <v-row
                                v-if="projectTotalRows.items1"
                                class="mt-4"
                              >
                                <v-col class="pagination-col">
                                  <v-pagination
                                    v-model="projectCurrentPage"
                                    :length="
                                      Math.ceil(
                                        projectTotalRows.items1 / perPage
                                      )
                                    "
                                    :total-visible="5"
                                    prev-icon="arrow_back"
                                    next-icon="arrow_forward"
                                    class="float-left"
                                  ></v-pagination>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel @change="projectCurrentPage = 1">
                      <v-expansion-panel-header
                        >طرح های پسادکتری حمایت شده</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <div class="py-6">
                          <v-row>
                            <v-col>
                              <b-table
                                responsive
                                small
                                show-empty
                                stacked="sm"
                                tbody-tr-class="trClass"
                                thead-class="thClass"
                                empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                :items="projects.items2"
                                :fields="projectFields"
                                :current-page="projectCurrentPage"
                                :per-page="perPage"
                                :filter="filter"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(progress)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{
                                      data.value != "-"
                                        ? "%" + data.value
                                        : data.value
                                    }}
                                  </div>
                                </template>
                                <template v-slot:cell(mehvar)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{
                                      data.index +
                                      perPage * (projectCurrentPage - 1) +
                                      1
                                    }}
                                  </div>
                                </template>
                              </b-table>
                              <v-row
                                class="mt-4"
                                v-if="projectTotalRows.items2"
                              >
                                <v-col class="pagination-col">
                                  <v-pagination
                                    v-model="projectCurrentPage"
                                    :length="
                                      Math.ceil(
                                        projectTotalRows.items2 / perPage
                                      )
                                    "
                                    :total-visible="5"
                                    prev-icon="arrow_back"
                                    next-icon="arrow_forward"
                                    class="float-left"
                                  ></v-pagination>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel @change="projectCurrentPage = 1">
                      <v-expansion-panel-header
                        >رساله های دکتری حمایت شده</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <div class="py-6">
                          <v-row>
                            <v-col>
                              <b-table
                                responsive
                                small
                                show-empty
                                stacked="sm"
                                tbody-tr-class="trClass"
                                thead-class="thClass"
                                empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                :items="projects.items3"
                                :fields="projectFields"
                                :current-page="projectCurrentPage"
                                :per-page="perPage"
                                :filter="filter"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(progress)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{
                                      data.value != "-"
                                        ? "%" + data.value
                                        : data.value
                                    }}
                                  </div>
                                </template>
                                <template v-slot:cell(mehvar)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{
                                      data.index +
                                      perPage * (projectCurrentPage - 1) +
                                      1
                                    }}
                                  </div>
                                </template>
                              </b-table>
                              <v-row
                                class="mt-4"
                                v-if="projectTotalRows.items3"
                              >
                                <v-col class="pagination-col">
                                  <v-pagination
                                    v-model="projectCurrentPage"
                                    :length="
                                      Math.ceil(
                                        projectTotalRows.items3 / perPage
                                      )
                                    "
                                    :total-visible="5"
                                    prev-icon="arrow_back"
                                    next-icon="arrow_forward"
                                    class="float-left"
                                  ></v-pagination>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel @change="projectCurrentPage = 1">
                      <v-expansion-panel-header
                        >پایان نامه های کارشناسی ارشد حمایت
                        شده</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <div class="py-6">
                          <v-row>
                            <v-col>
                              <b-table
                                responsive
                                small
                                show-empty
                                stacked="sm"
                                tbody-tr-class="trClass"
                                thead-class="thClass"
                                empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                :items="projects.items4"
                                :fields="projectFields"
                                :current-page="projectCurrentPage"
                                :per-page="perPage"
                                :filter="filter"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(progress)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{
                                      data.value != "-"
                                        ? "%" + data.value
                                        : data.value
                                    }}
                                  </div>
                                </template>
                                <template v-slot:cell(mehvar)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{
                                      data.index +
                                      perPage * (projectCurrentPage - 1) +
                                      1
                                    }}
                                  </div>
                                </template>
                              </b-table>
                              <v-row
                                class="mt-4"
                                v-if="projectTotalRows.items4"
                              >
                                <v-col class="pagination-col">
                                  <v-pagination
                                    v-model="projectCurrentPage"
                                    :length="
                                      Math.ceil(
                                        projectTotalRows.items4 / perPage
                                      )
                                    "
                                    :total-visible="5"
                                    prev-icon="arrow_back"
                                    next-icon="arrow_forward"
                                    class="float-left"
                                  ></v-pagination>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel @change="projectCurrentPage = 1">
                      <v-expansion-panel-header
                        >فرصت‌های مطالعاتی حمایت شده</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <div class="py-6">
                          <v-row>
                            <v-col>
                              <b-table
                                responsive
                                small
                                show-empty
                                stacked="sm"
                                tbody-tr-class="trClass"
                                thead-class="thClass"
                                empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                :items="projects.items5"
                                :fields="projectFields"
                                :current-page="projectCurrentPage"
                                :per-page="perPage"
                                :filter="filter"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(progress)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{
                                      data.value != "-"
                                        ? "%" + data.value
                                        : data.value
                                    }}
                                  </div>
                                </template>
                                <template v-slot:cell(mehvar)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{
                                      data.index +
                                      perPage * (projectCurrentPage - 1) +
                                      1
                                    }}
                                  </div>
                                </template>
                              </b-table>
                              <v-row
                                class="mt-4"
                                v-if="projectTotalRows.items5"
                              >
                                <v-col class="pagination-col">
                                  <v-pagination
                                    v-model="projectCurrentPage"
                                    :length="
                                      Math.ceil(
                                        projectTotalRows.items5 / perPage
                                      )
                                    "
                                    :total-visible="5"
                                    prev-icon="arrow_back"
                                    next-icon="arrow_forward"
                                    class="float-left"
                                  ></v-pagination>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel @change="projectCurrentPage = 1">
                      <v-expansion-panel-header
                        >نشست‌های استانی حمایت شده</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <div class="py-6">
                          <v-row>
                            <v-col>
                              <b-table
                                responsive
                                small
                                show-empty
                                stacked="sm"
                                tbody-tr-class="trClass"
                                thead-class="thClass"
                                empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                :items="projects.items6"
                                :fields="projectFields"
                                :current-page="projectCurrentPage"
                                :per-page="perPage"
                                :filter="filter"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(progress)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{
                                      data.value != "-"
                                        ? "%" + data.value
                                        : data.value
                                    }}
                                  </div>
                                </template>
                                <template v-slot:cell(mehvar)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{
                                      data.index +
                                      perPage * (projectCurrentPage - 1) +
                                      1
                                    }}
                                  </div>
                                </template>
                              </b-table>
                              <v-row
                                class="mt-4"
                                v-if="projectTotalRows.items6"
                              >
                                <v-col class="pagination-col">
                                  <v-pagination
                                    v-model="projectCurrentPage"
                                    :length="
                                      Math.ceil(
                                        projectTotalRows.items6 / perPage
                                      )
                                    "
                                    :total-visible="5"
                                    prev-icon="arrow_back"
                                    next-icon="arrow_forward"
                                    class="float-left"
                                  ></v-pagination>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel @change="projectCurrentPage = 1">
                      <v-expansion-panel-header
                        >مقالات زیست فناوری حمایت شده</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <div class="py-6">
                          <v-row>
                            <v-col>
                              <b-table
                                responsive
                                small
                                show-empty
                                stacked="sm"
                                tbody-tr-class="trClass"
                                thead-class="thClass"
                                empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                :items="projects.items7"
                                :fields="projectFields"
                                :current-page="projectCurrentPage"
                                :per-page="perPage"
                                :filter="filter"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(progress)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{
                                      data.value != "-"
                                        ? "%" + data.value
                                        : data.value
                                    }}
                                  </div>
                                </template>
                                <template v-slot:cell(mehvar)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{
                                      data.index +
                                      perPage * (projectCurrentPage - 1) +
                                      1
                                    }}
                                  </div>
                                </template>
                              </b-table>
                              <v-row
                                class="mt-4"
                                v-if="projectTotalRows.items7"
                              >
                                <v-col class="pagination-col">
                                  <v-pagination
                                    v-model="projectCurrentPage"
                                    :length="
                                      Math.ceil(
                                        projectTotalRows.items7 / perPage
                                      )
                                    "
                                    :total-visible="5"
                                    prev-icon="arrow_back"
                                    next-icon="arrow_forward"
                                    class="float-left"
                                  ></v-pagination>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel @change="projectCurrentPage = 1">
                      <v-expansion-panel-header
                        >مقالات زیست فناوری حمایت شده</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <div class="py-6">
                          <v-row>
                            <v-col>
                              <b-table
                                responsive
                                small
                                show-empty
                                stacked="sm"
                                tbody-tr-class="trClass"
                                thead-class="thClass"
                                empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                :items="projects.items8"
                                :fields="projectFields"
                                :current-page="projectCurrentPage"
                                :per-page="perPage"
                                :filter="filter"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell(progress)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{
                                      data.value != "-"
                                        ? "%" + data.value
                                        : data.value
                                    }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(mehvar)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                      max-width: 350px;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{
                                      data.index +
                                      perPage * (projectCurrentPage - 1) +
                                      1
                                    }}
                                  </div>
                                </template>
                              </b-table>
                              <v-row
                                class="mt-4"
                                v-if="projectTotalRows.items8"
                              >
                                <v-col class="pagination-col">
                                  <v-pagination
                                    v-model="projectCurrentPage"
                                    :length="
                                      Math.ceil(
                                        projectTotalRows.items8 / perPage
                                      )
                                    "
                                    :total-visible="5"
                                    prev-icon="arrow_back"
                                    next-icon="arrow_forward"
                                    class="float-left"
                                  ></v-pagination>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
      <div v-if="stepNumber == 2 && selectedReviewer.id">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row class="my-4">
            <v-col class="d-flex flex-row">
              <div class="profileImg-box">
                <img
                  :src="
                    selectedReviewer.avatar
                      ? selectedReviewer.avatar
                      : 'https://www.luminous-edu.com/wp-content/uploads/2020/06/blank-profile-picture-973460_640.png'
                  "
                  alt=""
                />
              </div>
              <div class="pa-4 fs-large c-dark">
                {{ selectedReviewer.name }}
                <p class="fs-small grey--text">داور</p>
              </div>
            </v-col>
            <v-col class="text-sm-left text-center">
              <v-btn
                class="bc-primary text-white btn-radius"
                width="200"
                height="47"
                elevation="0"
                @click="saveDocx('doc')"
              >
                <span class="fs-small">
                  خروجی ورد

                  <v-icon>$Word</v-icon></span
                >
              </v-btn>
            </v-col>
          </v-row>
          <v-tabs v-model="tab">
            <v-tab class="tab-title">مشخصات فرد</v-tab>
            <v-tab class="tab-title" v-if="deviceType == 'desktop'"
              >نمودار‌ها</v-tab
            >
            <v-tab class="tab-title">جدول‌ها</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <!-- مشخصات فرد -->
            <v-tab-item>
              <div class="py-10">
                <div class="fs-xxlarge c-dark text-right">مشخصات فردی</div>
                <v-card flat class="info-card mt-10 pa-sm-8 pe-0">
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >نام</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.name
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >آخرین مدرک تحصیلی</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.lastEducationDegree
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >نام خانوادگی</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.lastName
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >دانشگاه محل تحصیل</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.university
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >کد ملی</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.nationalCode
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark">
                            شماره تماس</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.mobile
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-row>
                        <v-col class="text-right">
                          <span class="fs-medium font-weight-bold c-dark"
                            >استان</span
                          >
                        </v-col>
                        <v-col class="text-right">
                          <span class="fs-medium c-grey">{{
                            personInfo.state
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-tab-item>
            <!-- نمودار -->
            <v-tab-item v-if="deviceType == 'desktop'">
              <v-container class="py-10 pe-5 ps-5">
                <div class="text-center" v-if="!allData.barChartHasData">
                  <hr />
                  موردی برای نمایش وجود ندارد.
                  <hr />
                </div>
                <div v-if="allData.barChartHasData" id="capture3" class="pa-6">
                  <v-row class="mb-6">
                    <v-col md="6" sm="6" cols="12"
                      ><h5 class="fs-xlarge pt-3">
                        نمودار فراوانی داوری‌ها به تفکیک حمایت‌ها
                      </h5></v-col
                    >
                    <v-spacer></v-spacer>
                    <v-col class="text-left" md="6" sm="6" cols="12">
                      <span v-show="false">{{ reactivity }}</span>
                      <v-btn
                        class="bc-primary text-white btn-radius"
                        width="200"
                        height="47"
                        data-html2canvas-ignore
                        elevation="0"
                        @click="
                          capture(
                            'capture3',
                            'نمودار-فراوانی-داوری‌ها-به-تفکیک-حمایت‌ها',
                            0
                          )
                        "
                        :loading="gettingPic[0]"
                      >
                        <template v-slot:loader>
                          <span class="white--text fs-xsmall d-flex flex-row">
                            <span
                              ><v-icon class="white--text"
                                >mdi-timer-sand-empty</v-icon
                              >
                              چند لحظه صبر کنید...
                            </span>
                          </span>
                        </template>
                        <span class="fs-small">
                          خروجی عکس

                          <v-icon>$Camera</v-icon></span
                        >
                      </v-btn>
                      <a id="download"></a>
                    </v-col>
                  </v-row>
                  <Chart
                    name="barChart2"
                    :chartdata="dataBar1"
                    :options="optionsBar3"
                    type="bar"
                    :height="deviceType != 'mobile' ? '200' : '400'"
                    v-if="barLoaded"
                  ></Chart>
                </div>
              </v-container>
            </v-tab-item>
            <!-- جدول -->
            <v-tab-item>
              <div class="py-10">
                <div class="main-table">
                  <div v-if="deviceType == 'mobile'">
                    <h4 class="mt-6 text-sm-right text-center">
                      جدول فراوانی داوری‌ها به تفکیک حمایت‌ها
                    </h4>
                    <div class="text-sm-left text-center">
                      <v-btn
                        class="bc-primary text-white btn-radius mt-5 mb-10"
                        width="200"
                        height="47"
                        elevation="0"
                        @click="$refs.table1.$el.click()"
                      >
                        <span class="fs-small">
                          خروجی اکسل

                          <v-icon>$Excel</v-icon></span
                        >
                      </v-btn>
                      <vue-excel-xlsx
                        v-show="false"
                        ref="table1"
                        :data="barTable"
                        :columns="excelBarFields2"
                        :filename="'جدول-فراوانی-حمایت‌ها'"
                        :sheetname="currentDate"
                      >
                        دریافت اکسل
                      </vue-excel-xlsx>
                    </div>
                    <b-table
                      responsive
                      small
                      show-empty
                      stacked="sm"
                      tbody-tr-class="trClass"
                      thead-class="thClass"
                      empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                      :items="barTable"
                      :fields="barFields2"
                      :current-page="barCurrentPage"
                      :per-page="perPage"
                      :filter="filter"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(mahvars)="data">
                        <div style="vertical-align: middle; max-width: 350px">
                          <ul>
                            <li
                              v-for="(item, index) in data.value"
                              :key="index"
                            >
                              {{ item }}
                            </li>
                          </ul>
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + perPage * (barCurrentPage - 1) + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <v-row v-if="barTotalRows">
                      <v-col>
                        <v-pagination
                          v-model="barCurrentPage"
                          :length="Math.ceil(barTotalRows / perPage)"
                          :total-visible="5"
                          prev-icon="arrow_back"
                          next-icon="arrow_forward"
                          class="float-left"
                        ></v-pagination>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row>
                    <v-col md="6" cols="12">
                      <h5 class="mt-6 fs-xlarge text-sm-right text-center pt-3">
                        جدول فراوانی وضعیت داوری‌ها
                      </h5>
                    </v-col>
                    <v-col md="6" cols="12">
                      <div class="text-sm-left text-center">
                        <v-btn
                          class="bc-primary text-white btn-radius mt-5 mb-10"
                          width="200"
                          height="47"
                          elevation="0"
                          @click="$refs.table3.$el.click()"
                        >
                          <span class="fs-small">
                            خروجی اکسل

                            <v-icon>$Excel</v-icon></span
                          >
                        </v-btn>
                        <vue-excel-xlsx
                          v-show="false"
                          ref="table3"
                          :data="items"
                          :columns="reviewersExcelFields"
                          :filename="'جدول-فراوانی-داوری‌ها'"
                          :sheetname="currentDate"
                        >
                          دریافت اکسل
                        </vue-excel-xlsx>
                      </div>
                    </v-col>
                  </v-row>
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                    :items="items"
                    :fields="reviewersFields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell(key)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          data.value == "totalCount"
                            ? "کل داوری‌ها"
                            : data.value == "dones"
                            ? "انجام شده"
                            : data.value == "ongoings"
                            ? "در دست انجام"
                            : data.value == "expireds"
                            ? "منقضی شده"
                            : ""
                        }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + perPage * (currentPage - 1) + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
      <v-row v-if="!pageLoading" class="mt-8">
        <v-col
          class="text-right"
          v-if="stepNumber == 1"
          md="4"
          sm="6"
          cols="12"
        >
          <v-btn
            class="bc-primary text-white no-underline btn-radius w-100"
            elevation="0"
            height="43"
            @click="nextStep()"
            :disabled="computedNextButton"
            >گام بعدی</v-btn
          >
        </v-col>
        <v-col class="text-right" md="4" sm="6" cols="12">
          <v-btn
            class="b-primary bc-white c-primary no-underline btn-radius w-100"
            elevation="0"
            height="43"
            @click="previousStep()"
            v-if="stepNumber == 2"
            >گام قبلی</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div class="goToDown" @click="goDown()">
      <v-icon>mdi-chevron-down</v-icon>
    </div>
    <!-- docx -->
    <div v-show="false" v-if="selectedResearcher.id" id="doc">
      <div style="direction: rtl">
        <h2 style="text-align: center">گزارش فردی پژوهشگر</h2>
        <br />
        <h3 class="c-dark" style="text-align: right">مشخصات فردی</h3>
        <table>
          <tr>
            <td style="background-color: #f1f1f1; padding: 0 5px">نام</td>
            <td style="padding: 0 5px">{{ personInfo.name }}</td>
            <td style="background-color: #f1f1f1; padding: 0 5px">
              آخرین مدرک تحصیلی
            </td>
            <td style="padding: 0 5px">{{ personInfo.lastEducationDegree }}</td>
          </tr>
          <tr>
            <td style="background-color: #f1f1f1; padding: 0 5px">
              نام خانوادگی
            </td>
            <td style="padding: 0 5px">{{ personInfo.lastName }}</td>
            <td style="background-color: #f1f1f1; padding: 0 5px">
              دانشگاه محل تحصیل
            </td>
            <td style="padding: 0 5px">{{ personInfo.university }}</td>
          </tr>
          <tr>
            <td style="background-color: #f1f1f1; padding: 0 5px">کد ملی</td>
            <td style="padding: 0 5px">{{ personInfo.nationalCode }}</td>
            <td style="background-color: #f1f1f1; padding: 0 5px">
              دانشگاه محل اشتغال
            </td>
            <td style="padding: 0 5px">{{ personInfo.universityJob }}</td>
          </tr>
          <tr>
            <td style="background-color: #f1f1f1; padding: 0 5px">استان</td>
            <td style="padding: 0 5px">{{ personInfo.state }}</td>
            <td style="background-color: #f1f1f1; padding: 0 5px">
              شماره تماس
            </td>
            <td style="padding: 0 5px">{{ personInfo.mobile }}</td>
          </tr>
        </table>
        <br />
        <div v-if="barTable.length">
          <h3 class="mt-6">جدول فراوانی حمایت‌ها</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="barTable"
            :fields="barFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="pieTable.length">
          <h3 class="mt-10">جدول تقسیم بندی نسبی حمایت‌ها</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="pieTable"
            :fields="pieFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(mahvars)="data">
              <div style="vertical-align: middle; max-width: 350px">
                <ul>
                  <li v-for="(item, index) in data.value" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="items.length">
          <h3 class="mt-10">جدول فراوانی سال‌ها</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="items"
            :fields="Fields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items1.length">
          <h3 class="mt-10">طرح های پیشنهادی فناورانه حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items1"
            :fields="projectFields"
            :filter="filter"
            head-variant="light"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items2.length">
          <h3 class="mt-10">طرح های پسادکتری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items2"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items3.length">
          <h3 class="mt-10">رساله های دکتری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items3"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items4.length">
          <h3 class="mt-10">پایان نامه های کارشناسی ارشد حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items4"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items5.length">
          <h3 class="mt-10">فرصت‌های مطالعاتی حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items5"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items6.length">
          <h3 class="mt-10">نشست‌های استانی حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items6"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items7.length">
          <h3 class="mt-10">مقالات زیست فناوری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items7"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items8.length">
          <h3 class="mt-10">مقالات زیست فناوری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items8"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <div v-show="false" v-if="selectedReviewer.id" id="doc">
      <div style="direction: rtl">
        <h2 style="text-align: center">گزارش فردی داور</h2>
        <br />
        <h3 class="c-dark" style="text-align: right">مشخصات فردی</h3>
        <table>
          <tr>
            <td style="background-color: #f1f1f1; padding: 0 5px">نام</td>
            <td style="padding: 0 5px">{{ personInfo.name }}</td>
            <td style="background-color: #f1f1f1; padding: 0 5px">
              آخرین مدرک تحصیلی
            </td>
            <td style="padding: 0 5px">{{ personInfo.lastEducationDegree }}</td>
          </tr>
          <tr>
            <td style="background-color: #f1f1f1; padding: 0 5px">
              نام خانوادگی
            </td>
            <td style="padding: 0 5px">{{ personInfo.lastName }}</td>
            <td style="background-color: #f1f1f1; padding: 0 5px">
              دانشگاه محل تحصیل
            </td>
            <td style="padding: 0 5px">{{ personInfo.university }}</td>
          </tr>
          <tr>
            <td style="background-color: #f1f1f1; padding: 0 5px">کد ملی</td>
            <td style="padding: 0 5px">{{ personInfo.nationalCode }}</td>
            <td style="background-color: #f1f1f1; padding: 0 5px">
              شماره تماس
            </td>
            <td style="padding: 0 5px">{{ personInfo.mobile }}</td>
          </tr>
          <tr>
            <td style="background-color: #f1f1f1; padding: 0 5px">استان</td>
            <td style="padding: 0 5px">{{ personInfo.state }}</td>
          </tr>
        </table>
        <br />
        <div v-if="barTable.length">
          <h3 class="mt-6">جدول فراوانی داوری‌ها به تفکیک حمایت‌ها</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="barTable"
            :fields="barFields2"
            :current-page="barCurrentPage"
            :per-page="perPage"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(mahvars)="data">
              <div style="vertical-align: middle; max-width: 350px">
                <ul>
                  <li v-for="(item, index) in data.value" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage * (barCurrentPage - 1) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="items.length">
          <h3 class="mt-10">جدول فراوانی وضعیت داوری‌ها</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="items"
            :fields="reviewersFields"
            :current-page="currentPage"
            :per-page="perPage"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage * (currentPage - 1) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import Chart from "../../../components/charts/Chart.vue";
import screenShot from "../../../mixins/screenShot";
//import { set } from "vue/types/umd";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Chart,
  },
  mixins: [screenShot],
  data() {
    return {
      optionsBar3: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            rtl: true,
            display: false,
            position: "right",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
              // filter: function (item) {
              //   // Logic to remove a particular legend item goes here
              //   return !item.text.includes(" ");
              // },
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            ticks: {
              stepSize: 5,
              beginAtZero: true,
              font: { family: "iransans" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      tab: null,
      personTab: null,
      filter: "",
      filter2: "",
      vLoading: false,
      researchers: [],
      reviewers: [],
      isSelected: false,
      selectedResearcher: {},
      selectedReviewer: {},
      selectedUniversity: [],
      stepNumber: 1,
      university: [],
      timeType: "",
      selectYearDialog: false,
      selectTimeRangeDialog: false,
      selectDayModal: false,
      items: [],
      reviewersFields: [
        { key: "key", label: "وضعیت" },
        { key: "value", label: "تعداد" },
      ],
      reviewersExcelFields: [
        { field: "total", label: "تعداد کل" },
        { field: "dones", label: "انجام شده" },
        { field: "ongoings", label: "در دست انجام" },
        { field: "expireds", label: "منقضی شده" },
      ],
      excelFields: [
        { field: "year", label: "سال" },
        { field: "project", label: "طرح تحقیقاتی" },
        { field: "opportune", label: "فرصت مطالعاتی" },
        { field: "phd", label: "رساله دکتری" },
        { field: "meeting", label: "نشست تخصصی" },
        { field: "master", label: "پایان نامه ارشد" },
        { field: "postDoc", label: "دوره پسادکتری" },
        { field: "article", label: "مقاله ISI" },
        { field: "elite", label: "نخبه وظیفه" },
      ],
      Fields: [
        { key: "year", label: "سال" },
        { key: "project", label: "طرح تحقیقاتی" },
        { key: "opportune", label: "فرصت مطالعاتی" },
        { key: "phd", label: "رساله دکتری" },
        { key: "meeting", label: "نشست تخصصی" },
        { key: "master", label: "پایان نامه ارشد" },
        { key: "postDoc", label: "دوره پسادکتری" },
        { key: "article", label: "مقاله ISI" },
        { key: "elite", label: "نخبه وظیفه" },
      ],
      currentPage: 1,
      totalRows: "",
      perPage: 10,
      barCurrentPage: 1,
      barTotalRows: "",
      pieCurrentPage: 1,
      pieTotalRows: "",
      personsCurrentPage: 1,
      personsCurrentPage2: 1,
      personTotalRows: "",
      personPerPage: 12,
      projects: {
        items1: [],
        items2: [],
        items3: [],
        items4: [],
        items5: [],
        items6: [],
        items7: [],
        items8: [],
      },
      projectFields: [
        { key: "index", label: "#" },
        { key: "faSubject", label: "عنوان طرح" },
        { key: "requestsCode", label: "کد طرح" },
        // { key: "type", label: "نوع طرح" },
        // { key: "requests", label: "تعداد حمایت‌ها" },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "finalDate", label: "تاریخ پایان" },
        { key: "progress", label: "درصد پیشرفت" },
        { key: "companyName", label: "نام شرکت دانش بنیان" },
        // { key: "executor", label: "نام مجری طرح" },
        { key: "zones", label: "حوزه فعالیت" },
        { key: "mehvar", label: "محور تقسیم کار ملی" },
        { key: "observer", label: "نام ناظر طرح" },
      ],
      projectCurrentPage: 1,
      projectTotalRows: {
        items1: null,
        items2: null,
        items3: null,
        items4: null,
        items5: null,
        items6: null,
        items7: null,
        items8: null,
      },
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      year: moment(new Date()).format("jYYYY"),
      selectedYear: "",
      currentYear: moment(new Date()).format("jYYYY"),
      range: {
        fromYear: parseInt(moment(new Date()).format("jYYYY")) - 1,
        fromMonth: moment(new Date()).format("jMM"),
        fromDay: moment(new Date()).format("jDD"),
        toYear: moment(new Date()).format("jYYYY"),
        toMonth: moment(new Date()).format("jMM"),
        toDay: moment(new Date()).format("jDD"),
      },
      selectedRange: {},
      fromNumberOfDay: null,
      toNumberOfDay: null,
      dateType: "",
      barBusy: false,
      doughnutBusy: false,
      barLoaded: false,
      doughnutLoaded: false,
      dataBar: {
        labels: [],
        datasets: [],
      },
      optionsBar1: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
            position: "top",
            align: "start",
            rtl: true,
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
              filter: function (item) {
                // Logic to remove a particular legend item goes here
                return item.text != "";
              },
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            ticks: {
              beginAtZero: true,
              font: { family: "iransans" },
            },
          },
          x: {
            ticks: {
              barThickness: 45,
              barPercentage: 1.0,
              categoryPercentage: 0.8,
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      dataPie: {
        labels: [],
        datasets: [],
      },
      optionsBar2: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: 40,
        plugins: {
          legend: {
            display: false,
            position: "left",
            fontSize: 16,
            rtl: true,
            labels: {
              font: {
                family: "iransans",
                size: 16,
              },
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },
      },
      deviceType: "",
      personInfo: {},
      pageLoading: false,
      reactivity: true,
      allData: {},
      barTable: [],
      pieTable: [],
      barFields: [
        { key: "name", label: "عنوان" },
        { key: "data", label: "تعداد" },
        { key: "data2", label: "تعداد کل" },
      ],
      barFields2: [
        { key: "name", label: "حمایت" },
        { key: "data", label: "داوری‌های انجام شده" },
        { key: "data2", label: "داوری‌های در دست انجام" },
        { key: "data3", label: "داوری‌های منقضی شده" },
        { key: "data4", label: "تعداد کل در حمایت" },
      ],
      excelBarFields2: [
        { field: "name", label: "حمایت" },
        { field: "data", label: "داوری‌های انجام شده" },
        { field: "data2", label: "داوری‌های در دست انجام" },
        { field: "data3", label: "داوری‌های منقضی شده" },
        { field: "data4", label: "تعداد کل در حمایت" },
      ],
      excelBarFields: [
        // { key: "index", label: "#" },
        { field: "name", label: "عنوان" },
        { field: "data", label: "تعداد" },
        { field: "data2", label: "تعداد کل" },
      ],
      pieFields: [
        // { key: "index", label: "#" },
        { key: "name", label: "عنوان" },
        { key: "data", label: "تعداد" },
      ],
      excelPieFields: [
        // { key: "index", label: "#" },
        { field: "name", label: "عنوان" },
        { field: "data", label: "تعداد" },
      ],
    };
  },
  methods: {
    choosePerson(item, role) {
      if (role == "researcher") {
        this.selectedReviewer = {};
        this.selectedResearcher = item;
      } else {
        this.selectedResearcher = {};
        this.selectedReviewer = item;
      }
    },
    chooseUniversity(item) {
      if (
        this.selectedUniversity.length &&
        this.selectedUniversity.includes(item.name)
      ) {
        let index;
        index = this.selectedUniversity.indexOf(item.name);
        this.selectedUniversity.splice(index, 1);
      } else {
        this.selectedUniversity.push(item.name);
      }
    },
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} @font-face { font-family: projectMainFont; src: url('/Vazir.ttf');} @media print{table {page-break-inside: avoid;}} body{font-family: projectMainFont;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename =
        "گزارش-فردی(" +
        (this.selectedResearcher.id
          ? this.selectedResearcher.name
          : this.selectedReviewer.name) +
        ").doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    nextStep() {
      this.tab = 0;
      this.getPersonInfo();
      this.filter = "";
      ++this.stepNumber;
      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
      if (this.stepNumber == 2) {
        this.getUniversities();
      }
    },
    previousStep() {
      this.filter = "";
      --this.stepNumber;
      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    },
    goDown() {
      var container = document.querySelector("html");
      var scrollHeight = container.scrollHeight;
      container.scrollTop = scrollHeight;
    },
    goFirst(role) {
      if (role == "researcher") {
        this.personsCurrentPage = 1;
      } else {
        this.personsCurrentPage2 = 1;
      }
    },

    getPersons() {
      this.pageLoading = true;
      // get researchers
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reports/researchers/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.researchers = res.data;
          this.personTotalRows = this.researchers.length;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });

      //get reviewers
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reports/reviewers/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.reviewers = res.data;
          this.personTotalRows = this.reviewers.length;
          // this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getPersonInfo() {
      this.pageLoading = true;
      this.barBusy = true;
      this.doughnutBusy = true;
      if (this.selectedResearcher.id) {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/reports/researchers/getInfo",
            {
              researcherId: this.selectedResearcher.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            // personal info
            this.allData = res.data;
            this.personInfo = res.data.profile;

            // tables
            this.items = res.data.yearTable;
            this.projects.items1 = res.data.project;
            this.projects.items2 = res.data.postDoc;
            this.projects.items3 = res.data.phd;
            this.projects.items4 = res.data.master;
            this.projects.items5 = res.data.opportune;
            this.projects.items6 = res.data.meeting;
            this.projects.items7 = res.data.article;
            this.projects.items8 = res.data.elite;
            // total rows
            this.totalRows = this.items.length;
            this.projectTotalRows.items1 = this.projects.items1.length;
            this.projectTotalRows.items2 = this.projects.items2.length;
            this.projectTotalRows.items3 = this.projects.items3.length;
            this.projectTotalRows.items4 = this.projects.items4.length;
            this.projectTotalRows.items5 = this.projects.items5.length;
            this.projectTotalRows.items6 = this.projects.items6.length;
            this.projectTotalRows.items7 = this.projects.items7.length;
            this.projectTotalRows.items8 = this.projects.items8.length;

            // charts
            this.dataBar = res.data.barChart;
            this.dataBar.datasets[0].barPercentage = 0.8;
            this.dataBar.datasets[0].borderRadius = 10;
            this.dataBar.datasets[1].barPercentage = 0.8;
            this.dataBar.datasets[1].borderRadius = 10;
            this.barBusy = false;
            this.dataPie = res.data.pieChart;
            this.doughnutBusy = false;

            this.barTable = this.dataBar.labels.map((label, index) => {
              return {
                name: label,
                data: this.dataBar.datasets[0].data[index],
                data2: this.dataBar.datasets[1].data[index],
              };
            });
            this.barTotalRows = this.barTable.length;
            this.pieTable = this.dataPie.labels.map((label, index) => {
              return {
                name: label,
                data: this.dataPie.datasets[0].data[index],
              };
            });
            this.pieTotalRows = this.pieTable.length;

            if (window.screen.width < 650 || document.body.clientWidth < 650) {
              this.optionsBar1.plugins.legend.labels.font.size = "8";
              this.optionsBar1.scales.x.ticks.font.size = "8";
              this.optionsBar1.scales.y.ticks.font.size = "8";
              this.optionsBar1.plugins.legend.position = "bottom";
            }
            if (window.screen.width < 650 || document.body.clientWidth < 650) {
              this.optionsBar2.plugins.legend.labels.font.size = "10";
              this.optionsBar2.plugins.legend.position = "top";
            }
            setTimeout(() => {
              this.barLoaded = true;
              this.doughnutLoaded = true;
              this.pageLoading = false;
            }, 1000);
          })
          .catch((err) => {
            this.vLoading = false;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/reports/reviewers/getInfo",
            {
              refereeId: this.selectedReviewer.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            // personal info
            this.allData = res.data;
            this.personInfo = res.data.profile;

            // tables
            this.items = res.data.reviewStatisitcs;

            // charts
            this.dataBar1 = res.data.barChart;
            this.barBusy = false;

            this.barTable = this.dataBar1.labels.map((label, index) => {
              return {
                name: label,
                data: this.dataBar1.datasets[0].data[index],
                data2: this.dataBar1.datasets[1].data[index],
                data3: this.dataBar1.datasets[2].data[index],
                data4: this.dataBar1.datasets[3].data[index],
              };
            });
            this.barTotalRows = this.barTable.length;

            if (window.screen.width < 650 || document.body.clientWidth < 650) {
              this.optionsBar1.plugins.legend.labels.font.size = "8";
              this.optionsBar1.scales.x.ticks.font.size = "8";
              this.optionsBar1.scales.y.ticks.font.size = "8";
              this.optionsBar1.plugins.legend.position = "bottom";
            }
            if (window.screen.width < 650 || document.body.clientWidth < 650) {
              this.optionsBar2.plugins.legend.labels.font.size = "10";
              this.optionsBar2.plugins.legend.position = "top";
            }
            setTimeout(() => {
              this.barLoaded = true;
              this.doughnutLoaded = true;
              this.pageLoading = false;
            }, 1000);
          })
          .catch((err) => {
            this.vLoading = false;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },
    goToSelectRange() {
      this.selectTimeRangeDialog = true;
      this.getNumberOfDays("from");
      this.getNumberOfDays("to");
    },
    getNumberOfDays(type) {
      if (type == "from") {
        if (1 <= parseInt(this.range.fromMonth) < 7) {
          this.fromNumberOfDay = 31;
        }
        if (
          7 <= parseInt(this.range.fromMonth) &&
          parseInt(this.range.fromMonth) != 12
        ) {
          this.fromNumberOfDay = 30;
        }
        if (parseInt(this.range.fromMonth) == 12) {
          let isLead = moment(
            this.range.fromYear + "/12/30",
            "jYYYY/jMM/jDD"
          ).isValid();
          if (isLead) {
            this.fromNumberOfDay = 30;
          } else this.fromNumberOfDay = 29;
        }
      } else {
        if (1 <= parseInt(this.range.toMonth) < 7) {
          this.toNumberOfDay = 31;
        }
        if (
          7 <= parseInt(this.range.toMonth) &&
          parseInt(this.range.toMonth) != 12
        ) {
          this.toNumberOfDay = 30;
        }
        if (parseInt(this.range.toMonth) == 12) {
          let isLead = moment(
            this.range.toYear + "/12/30",
            "jYYYY/jMM/jDD"
          ).isValid();
          alert(isLead);
          if (isLead) {
            this.toNumberOfDay = 30;
          } else this.toNumberOfDay = 29;
        }
      }
    },
    getUniversities() {
      this.university = [
        {
          avatar: "",
          name: "دانشگاه تهران",
        },
        {
          avatar: "",
          name: "دانشگاه صنعتی شریف",
        },
        {
          avatar: "",
          name: "دانشگاه امیرکبیر",
        },
        {
          avatar: "",
          name: "دانشگاه آزاد اسلامی",
        },
        {
          avatar: "",
          name: "دانشگاه علم و صنعت",
        },
        {
          avatar: "",
          name: "دانشگاه خواجه نصیر",
        },
        {
          avatar: "",
          name: "دانشگاه علوم پزشکی ایران",
        },
      ];
      //   this.vLoading = true;
      //   this.$http
      //     .post(
      //       this.baseUrl + "",
      //       {
      //        states: this.selectedResearcher
      //        },
      //       {
      //         headers: {
      //           Authorization: "Bearer: " + localStorage.getItem("userId"),
      //         },
      //       }
      //     )
      //     .then((res) => {
      //       this.university = res.data;
      //       this.vLoading = false;
      //     })
      //     .catch((err) => {
      //       this.vLoading = false;
      //       console.log(err)
      //     });
    },
  },
  computed: {
    computedResearchers() {
      let filtered;
      filtered = this.researchers.filter((x) => x.name.includes(this.filter));
      filtered = filtered.slice(
        12 * (this.personsCurrentPage - 1),
        12 * this.personsCurrentPage
      );
      return filtered;
    },
    computedReviewers() {
      let filtered;
      filtered = this.reviewers.filter((x) => x.name.includes(this.filter2));
      filtered = filtered.slice(
        12 * (this.personsCurrentPage2 - 1),
        12 * this.personsCurrentPage2
      );
      return filtered;
    },
    computedUniversities() {
      if (this.filter) {
        let filtered;
        filtered = this.university.filter((x) => x.name.includes(this.filter));
        return filtered;
      } else {
        return this.university;
      }
    },
    computedNextButton() {
      if (this.stepNumber == 1) {
        if (this.selectedResearcher.id || this.selectedReviewer.id) {
          return false;
        } else return true;
      }
    },
    computedCharts() {
      if (!this.allData.barChartHasData && !this.allData.pieChartHasData) {
        return true;
      } else return false;
    },
  },
  mounted() {
    if (window.screen.width < 500) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 500) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    this.gettingPic = [false, false];
    this.getPersons();
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  .edit-icon {
    path {
      stroke: #068d9d !important;
    }
    transform: translateY(-2px);
  }
  .v-card__title {
    border-radius: 10px 10px 0 0;
  }
  .day-box {
    width: 37px;
    height: 37px;
    text-align: center;
    border-radius: 50%;
    padding-top: 8px;
    color: #656a81;
    &:hover {
      background-color: #eeeeee;
    }
    &.selected {
      background-color: #e6e6e6;
      color: #068d9d;
      font-weight: bold;
    }
  }
}
.researchers-page {
  min-height: 400px;
  padding: 15px;
}
</style>
